import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ToggleComponent } from "src/app/shared/components/toggle/toggle.component";
import { Question } from 'src/app/models/question.model';
import { GlobalStore } from 'src/app/store/global-store';
import { OptionsList } from 'src/app/models/optionsList.model';
import { OptionsListApiService } from 'src/app/features/collections/services/options-list-api.service';

@Component({
    selector: 'que-expense',
    imports: [CommonModule, OverlayModule, TranslateDirective, TranslatePipe, ToggleComponent],
    templateUrl: './expense.component.html',
    styleUrls: ['./expense.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ExpenseComponent,
            multi: true
        }
    ]
})
export class ExpenseComponent implements OnInit, ControlValueAccessor {

  #builder = inject(FormBuilder);
  #globalStore = inject(GlobalStore);
  #optionsListApiService$ = inject(OptionsListApiService);

  questionForm = this.#builder.group({
    isDecimal: new FormControl<boolean>(false),
    allowMultipleFiles: new FormControl<boolean>(false),
    optionsListGuid: new FormControl<string | null>(null),
    optionsList: new FormControl<OptionsList | null>(null),

  });

  readonly positonArea = [{
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top'
  }] as ConnectedPosition[];

  allOptionLists$ = this.#globalStore.optionLists$;
  orginalQuestion?: Question;
  registerOnChangeCallback: any = () => { };
  selectedOptionExpenseName?: string;
  isSelectExpenseOpen: boolean = false;

  ngOnInit(): void {
    this.questionForm.valueChanges.subscribe(question => {
      this.registerOnChangeCallback({
        ...this.orginalQuestion,
        optionsList: question.optionsList,
        definitions: {
          ...this.orginalQuestion?.definitions,
          isDecimal: question.isDecimal,
          allowMultipleFiles: question.allowMultipleFiles
        }
      })
    })
  }

  writeValue(obj: Question): void {
    this.orginalQuestion = obj;
    this.questionForm.patchValue({
      optionsListGuid: obj.optionsList?.guid,
      optionsList: obj.optionsList,
      isDecimal: obj.definitions?.isDecimal,
      allowMultipleFiles: obj.definitions?.allowMultipleFiles
    }, { emitEvent: false })
    this.selectedOptionExpenseName = obj.optionsList?.name
  }
  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }


  markDecimal(value: boolean) {
    this.questionForm.controls.isDecimal.setValue(value)
  }

  markMultipleFiles(value: boolean) {
    this.questionForm.controls.allowMultipleFiles.setValue(value);
  }

  updateSelection(op: OptionsList) {
    this.questionForm.controls.optionsList.setValue(op);
    this.questionForm.controls.optionsListGuid.setValue(op.guid);
    this.#optionsListApiService$.getItemsByListId(op.guid).subscribe((x) => {
      this.questionForm.controls.optionsList.setValue({ ...op, answerOptionItem: x });
    });
    this.selectedOptionExpenseName = op.name ?? "";
    this.isSelectExpenseOpen = false;
  }
}
